module.exports = __webpack_public_path__ + "static/img/passo3.47e8d136.svg";